import { useState, useEffect } from 'react';
import config from '../config';
import { Customer } from '../interfaces';
import { useSession } from '../contexts/SessionContext';
import { useTranslation } from 'react-i18next';

interface FilterCriteria {
  ean: string | undefined;
}

const useFetchDeviceCrmByEan = (filterCriteria: FilterCriteria) => {
  const [crmResponse, setCrmResponse] = useState<Customer | null>(null);
  const [error, setError] = useState<string | null>(null);
  const { sessionState } = useSession();
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const refetch = () => setRefreshTrigger(prev => prev + 1);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchCrmDeviceByEan = async () => {
      try {
        const token = sessionState.account?.token;
        const response = await fetch(`${config.centralApiBaseUrl}/customer/byean/${filterCriteria.ean}`, {
          method: 'GET',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) {
          if (response.status === 404) {
            console.warn(t("errorMessageEmptyDatabase"))
            setCrmResponse(null);
            setError(null);
            return;
          }
          throw new Error('Failed to fetch items');
        }

        const data = await response.json();
        setCrmResponse(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An unknown error occurred');
      }
    };
    if (filterCriteria.ean && filterCriteria.ean !== '') {
      fetchCrmDeviceByEan();
      setError('');
    } else {
      setError('EAN cannot be empty');
    }
  }, [filterCriteria.ean, refreshTrigger]);

  return { crmResponse, error, refetch };
};

export default useFetchDeviceCrmByEan;
